function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * Manage state needed to display the password strength balloon, aka, Design F
 *
 * @export
 * @class PasswordStrengthBalloonModel
 * @extends {Model}
 */
import { assign, find } from 'underscore';
import AuthErrors from '../../lib/auth-errors';
import { Model } from 'backbone';
import { PASSWORD_MIN_LENGTH } from '../../lib/constants';
import { normalizeEmail } from 'fxa-shared/email/helpers';
const BANNED_SERVICE_NAMES = ['addons', 'firefox', 'fxaccount', 'firefox account', 'firefoxaccount', 'fxsync', 'firefox sync', 'firefoxsync', 'lockbox', 'fxlockbox', 'mozilla', 'sumo', 'sync' // These need to be sorted by length so that the largest match
// is found first in isPasswordMostlyCommonService
].sort((a, b) => b.length - a.length);
const BANNED_URL_REGEXP = /^(?:firefox|mozilla)\.(?:com|org)$/;

let PasswordStrengthBalloonModel = /*#__PURE__*/function (_Model) {
  _inherits(PasswordStrengthBalloonModel, _Model);

  var _super = _createSuper(PasswordStrengthBalloonModel);

  function PasswordStrengthBalloonModel() {
    var _this;

    let attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PasswordStrengthBalloonModel);

    const attrsWithDefaults = assign({
      email: '',
      hasUserTakenAction: false,
      isVisible: false,
      // The null default is so a `change:password` event fires if
      // the user submits the form with an empty password.
      password: null
    }, attrs);
    _this = _super.call(this, attrsWithDefaults, config);

    _this.on('change:password', () => _this.set('hasUserTakenAction', true)); // Force a validity check every time the password is updated.


    _this.on('change:password', () => _this.isValid());

    return _this;
  }

  _createClass(PasswordStrengthBalloonModel, [{
    key: "_getCommonPasswordList",
    value: function _getCommonPasswordList() {
      return import(
      /* webpackChunkName: "fxa-common-password-list" */
      'fxa-common-password-list');
    }
  }, {
    key: "fetch",
    value: function fetch() {
      return this._getCommonPasswordList().then(commonPasswordList => {
        this.commonPasswordList = commonPasswordList;
      });
    }
  }, {
    key: "isSameAsEmail",
    value: function isSameAsEmail(lowercasePassword) {
      const email = normalizeEmail(this.get('email'));
      return this.doesPasswordContainFullEmail(lowercasePassword, email) || this.isPasswordSubstringOfEmail(lowercasePassword, email) || this.isPasswordMostlyLocalPartOfEmail(lowercasePassword, email);
    }
  }, {
    key: "doesPasswordContainFullEmail",
    value: function doesPasswordContainFullEmail(lowercasePassword, email) {
      return lowercasePassword.indexOf(email) !== -1;
    }
  }, {
    key: "isPasswordSubstringOfEmail",
    value: function isPasswordSubstringOfEmail(lowercasePassword, email) {
      return email.indexOf(lowercasePassword) !== -1;
    }
  }, {
    key: "isPasswordMostlyLocalPartOfEmail",
    value: function isPasswordMostlyLocalPartOfEmail(lowercasePassword, email) {
      const _email$split = email.split('@'),
            _email$split2 = _slicedToArray(_email$split, 1),
            localPartOfEmail = _email$split2[0]; // if the local part comprises >= half of the password, banned.


      return this.isPasswordMostlyWord(lowercasePassword, localPartOfEmail);
    }
  }, {
    key: "isPasswordMostlyWord",
    value: function isPasswordMostlyWord(lowercasePassword, word) {
      return word.length * 2 >= lowercasePassword.length && lowercasePassword.indexOf(word) !== -1;
    }
  }, {
    key: "isPasswordMostlyCommonServiceName",
    value: function isPasswordMostlyCommonServiceName(lowercasePassword) {
      const matchingService = find(BANNED_SERVICE_NAMES, serviceName => {
        return lowercasePassword.indexOf(serviceName) !== -1;
      });

      if (matchingService) {
        return this.isPasswordMostlyWord(lowercasePassword, matchingService);
      }
    }
  }, {
    key: "isCommon",
    value: function isCommon(commonPasswordList, lowercasePassword) {
      // The password list only stores lowercase words
      // Consider common Firefox related services and URLs as banned.
      return commonPasswordList.test(lowercasePassword) || this.isPasswordMostlyCommonServiceName(lowercasePassword) || BANNED_URL_REGEXP.test(lowercasePassword);
    }
  }, {
    key: "validate",
    value: function validate() {
      let attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // If the user has taken no action and there is no password,
      // the data is not considered invalid.
      if (!attrs.hasUserTakenAction && !attrs.password) {
        return;
      } // The password list only stores lowercase words,
      // use the lowercase password for comparison everywhere.


      const lowercasePassword = (attrs.password || '').toLowerCase();

      if (!lowercasePassword) {
        return AuthErrors.toError('PASSWORD_REQUIRED');
      } else if (lowercasePassword.length < PASSWORD_MIN_LENGTH) {
        return AuthErrors.toError('PASSWORD_TOO_SHORT');
      } else if (this.isSameAsEmail(lowercasePassword)) {
        return AuthErrors.toError('PASSWORD_SAME_AS_EMAIL');
      } else if (this.isCommon(this.commonPasswordList, lowercasePassword)) {
        return AuthErrors.toError('PASSWORD_TOO_COMMON');
      }
    }
  }]);

  return PasswordStrengthBalloonModel;
}(Model);

export { PasswordStrengthBalloonModel as default };